import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '../components/Navbar';
const LandingPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [currentBgImage, setCurrentBgImage] = useState(0);
  const navigate = useNavigate();
  const backgroundImages = ['https://cdn.magicpatterns.com/uploads/9bRLzb2yD8yhvSM78PxnAX/8_X_10.jpg', 'https://cdn.magicpatterns.com/uploads/fjvnTVUQkEd37TmoTbHegn/DSC01256.jpg', 'https://cdn.magicpatterns.com/uploads/jsDGuLozu3hupQxh5nRhG5/DSC01370.jpg', 'https://cdn.magicpatterns.com/uploads/hg9YJ9TrcivT8o2GTTBauL/DSC01405.jpg'];
  useEffect(() => {
    // Auto-open after 2.5 seconds if user hasn't interacted
    const timer = setTimeout(() => {
      if (!hasInteracted) {
        setIsOpen(true);
      }
    }, 2500);
    return () => clearTimeout(timer);
  }, [hasInteracted]);
  useEffect(() => {
    // Rotate background images every 5 seconds
    const bgTimer = setInterval(() => {
      setCurrentBgImage(prev => (prev + 1) % backgroundImages.length);
    }, 5000);
    return () => clearInterval(bgTimer);
  }, []);
  const handleEnvelopeClick = () => {
    setHasInteracted(true);
    setIsOpen(true);
  };
  const handleEnvelopeHover = () => {
    setHasInteracted(true);
  };
  return <div className="min-h-screen bg-cream relative overflow-hidden" data-id="element-242">
      <Navbar data-id="element-243" />

      {/* Blurred background images - rotating slideshow */}
      <div className="absolute inset-0 z-0" data-id="element-244">
        {backgroundImages.map((image, index) => <div key={index} className={`absolute inset-0 bg-cover bg-center blur-md transition-opacity duration-1000 ${index === currentBgImage ? 'opacity-30' : 'opacity-0'}`} style={{
        backgroundImage: `url(${image})`
      }} data-id="element-245" />)}
        <div className="absolute inset-0 bg-gradient-to-b from-cream/80 to-sage/40" data-id="element-246" />
      </div>

      {/* Main content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center px-4 py-24" data-id="element-247">
        <div className="w-full max-w-2xl" data-id="element-248">
          {/* Envelope container */}
          <motion.div className="relative" style={{
          perspective: '1500px'
        }} initial={{
          opacity: 0,
          y: 50
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-249">
            {/* Envelope body */}
            <div className="relative cursor-pointer" onClick={handleEnvelopeClick} onMouseEnter={handleEnvelopeHover} data-id="element-250">
              {/* Back of envelope */}
              <div className="relative bg-cream-dark border-2 border-emerald/30 rounded-lg shadow-2xl overflow-hidden" data-id="element-251">
                <div className="aspect-[1.6/1] p-12 md:p-16" data-id="element-252">
                  {/* Decorative pattern - couple's photo */}
                  <div className="absolute inset-0 opacity-20" data-id="element-253">
                    <div className="absolute inset-0 bg-cover bg-center" style={{
                    backgroundImage: `url(https://cdn.magicpatterns.com/uploads/hQtW8dMZV2V2RqQs7skNd8/DSC01256.jpg)`
                  }} data-id="element-254" />
                  </div>

                  {/* Envelope flap - animated */}
                  <motion.div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-cream-dark to-cream-dark/90 border-b-2 border-emerald/30 origin-top" style={{
                  clipPath: 'polygon(0 0, 50% 100%, 100% 0)',
                  transformStyle: 'preserve-3d'
                }} animate={{
                  rotateX: isOpen ? -180 : 0
                }} transition={{
                  duration: 1.2,
                  ease: [0.43, 0.13, 0.23, 0.96]
                }} data-id="element-255">
                    {/* Emerald wax seal */}
                    <motion.div className="absolute top-20 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-emerald rounded-full shadow-lg flex items-center justify-center" animate={{
                    scale: isOpen ? 0 : 1,
                    opacity: isOpen ? 0 : 1
                  }} transition={{
                    duration: 0.4
                  }} data-id="element-256">
                      <span className="text-white font-script text-xl" data-id="element-257">
                        Abi<span className="text-red-500" data-id="element-258">❤</span>Aye
                      </span>
                    </motion.div>
                  </motion.div>

                  {/* Card inside envelope */}
                  <AnimatePresence data-id="element-259">
                    {isOpen && <motion.div className="relative z-20 bg-white rounded-lg shadow-xl p-8 md:p-12 border border-emerald/20" initial={{
                    y: 50,
                    opacity: 0,
                    scale: 0.9
                  }} animate={{
                    y: 0,
                    opacity: 1,
                    scale: 1
                  }} transition={{
                    delay: 0.6,
                    duration: 0.8,
                    ease: [0.43, 0.13, 0.23, 0.96]
                  }} data-id="element-260">
                        {/* Decorative top border */}
                        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-261">
                          <div className="w-16 h-16 bg-sage rounded-full flex items-center justify-center border-4 border-white" data-id="element-262">
                            <span className="text-emerald text-2xl" data-id="element-263">💚</span>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="text-center space-y-6 mt-4" data-id="element-264">
                          <p className="font-sans text-xs uppercase tracking-widest text-gray-600" data-id="element-265">
                            You're Invited
                          </p>

                          <h1 className="font-script text-5xl md:text-6xl text-gray-800 leading-tight" data-id="element-266">
                            Ayevbosa <span className="text-emerald" data-id="element-267">&</span>{' '}
                            Abiodun
                          </h1>

                          <div className="w-16 h-0.5 bg-emerald mx-auto" data-id="element-268" />

                          <p className="font-elegant text-lg text-gray-700" data-id="element-269">
                            March 14th, 2026 • Ibadan, Oyo State
                          </p>

                          {/* How We Met story */}
                          <div className="pt-4 pb-2" data-id="element-270">
                            <p className="text-gray-700 leading-relaxed text-sm md:text-base font-elegant" data-id="element-271">
                              It was June 1, 2016, in a 200-level Agric
                              Economics class when our story began. I needed to
                              copy some notes, and Ayevbosa kindly lent me hers.
                              From that moment, I was struck by how calm,
                              beautiful, and witty she was. What started as a
                              simple study partnership slowly blossomed into a
                              deep friendship and love.
                            </p>
                          </div>

                          {/* CTA Buttons */}
                          <div className="flex flex-col sm:flex-row gap-4 pt-6" data-id="element-272">
                            <button onClick={e => {
                          e.stopPropagation();
                          navigate('/rsvp');
                        }} className="flex-1 px-8 py-4 bg-emerald text-white font-sans text-sm uppercase tracking-wider hover:bg-emerald-dark transition-all duration-300 shadow-md hover:shadow-lg" data-id="element-273">
                              RSVP to Attend
                            </button>
                            <button onClick={e => {
                          e.stopPropagation();
                          navigate('/gifts');
                        }} className="flex-1 px-8 py-4 border-2 border-emerald text-emerald font-sans text-sm uppercase tracking-wider hover:bg-emerald hover:text-white transition-all duration-300" data-id="element-274">
                              Gift the Couple
                            </button>
                          </div>

                          {/* Explore more link */}
                          <div className="pt-4" data-id="element-275">
                            <button onClick={e => {
                          e.stopPropagation();
                          navigate('/our-story');
                        }} className="text-gray-600 hover:text-emerald text-sm underline transition-colors font-elegant" data-id="element-276">
                              Explore Our Full Story →
                            </button>
                          </div>
                        </div>
                      </motion.div>}
                  </AnimatePresence>

                  {/* Prompt text when closed */}
                  {!isOpen && <motion.div className="absolute inset-0 flex items-center justify-center" initial={{
                  opacity: 0
                }} animate={{
                  opacity: 1
                }} exit={{
                  opacity: 0
                }} data-id="element-277">
                      <div className="text-center space-y-4" data-id="element-278">
                        <p className="font-script text-3xl md:text-4xl text-gray-800" data-id="element-279">
                          You're Invited
                        </p>
                        <p className="font-sans text-sm text-gray-600 animate-pulse" data-id="element-280">
                          Click or hover to open
                        </p>
                      </div>
                    </motion.div>}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
};
export default LandingPage;